module.exports = __webpack_public_path__ + "img/cover-slot-bg-mobile.0c1b06c5.jpg";